import { cn } from './utils/cn';

const recursiveTableFromJson = (json: object) => {
  if (typeof json === 'object') {
    if (Array.isArray(json)) {
      return (
        <ul className="space-y-3">
          {json.map((item, index) => (
            <li key={index}>
              <div className="sticky top-1.5 z-10 mb-1 inline-block rounded-lg bg-fog p-0.5 px-2 font-bold">
                {index + 1}.
              </div>
              <div className="pl-5">{recursiveTableFromJson(item)}</div>
            </li>
          ))}
        </ul>
      );
    } else {
      return (
        <table className="relative">
          <tbody>
            {json &&
              Object.keys(json).map((key, i) => (
                <tr key={i} className="border border-ash">
                  <th
                    scope="row"
                    align="left"
                    className="relative bg-fog p-2 align-top"
                  >
                    <div className="sticky left-0 top-2">{key}</div>
                  </th>
                  <td className="border p-2">
                    {recursiveTableFromJson(json[key as keyof typeof json])}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      );
    }
  } else {
    return <span className="py-2">{String(json)}</span>;
  }
};

export const JSONTable = ({
  json,
  className,
}: {
  json: object;
  className?: string;
}) => {
  return (
    <div className={cn('relative text-[11px]', className)}>
      {recursiveTableFromJson(json)}
    </div>
  );
};
